import React from 'react';
import '../styles/modal.css';

const BookmarkModal = ({
  isOpen,
  onClose,
  onSelectOption,
  selectedOption,
  setSelectedOption
}) => {
  if (!isOpen) return null;

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleContinue = () => {
    if (selectedOption) {
      onSelectOption(selectedOption);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <p className="modal-subtitle"><span>Bookmark</span> & Get instant project updates.</p>
        <p className="modal-subtitle">How should we notify you?</p>

        <div className="options-container">
          <label className="option-item">
            <input
              type="radio"
              name="notification"
              value="whatsapp"
              checked={selectedOption === 'whatsapp'}
              onChange={handleOptionChange}
            />
            <span>Continue with WhatsApp</span>
          </label>

          <label className="option-item">
            <input
              type="radio"
              name="notification"
              value="email"
              checked={selectedOption === 'email'}
              onChange={handleOptionChange}
            />
            <span>Get updates via Email</span>
          </label>
        </div>

        <button
          className="continue-button"
          onClick={handleContinue}
          disabled={!selectedOption}
        >
          Continue
        </button>

        <button className="maybe-later" onClick={onClose}>
          Maybe Later
        </button>

        <p className="spam-note">No spam. Unsubscribe anytime</p>
      </div>
    </div>
  );
};

export default BookmarkModal;